import React, { FC, memo } from 'react';

import { HrStyled } from './styles';

const Hr: FC = () => (
  <HrStyled aria-hidden="true" />
);

export default memo(Hr);
